exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#components-pagination-demo-mini .ant-pagination[data-v-2026c8c0]:not(:last-child){margin-bottom:24px}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/components/settings/system_branch.vue"],"names":[],"mappings":"AACA,mFACE,kBAAoB,CACrB","file":"system_branch.vue","sourcesContent":["\n#components-pagination-demo-mini .ant-pagination[data-v-2026c8c0]:not(:last-child) {\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2026c8c0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/system_branch.vue
// module id = 1250
// module chunks = 2